import React from 'react';
import './VenueAnalysisGrid.scss';
import { VenueAnalysisData } from '../venueAnalysisAggregatedData';
import './OrderLiquidityBreakdown.scss';

import {
    isVenueSelected,
    VenueAnalysisSelection,
} from 'widgets/venueAnalysis/store/component/VenueAnalysisSelection';

import './OrderLiquidityVenueSankey.scss';
import { getVenueToLiquiditySankeyData } from 'widgets/venueAnalysis/grid/VenueAnalysisGridSankeyData';
import { VenueAnalysisSankey } from 'widgets/venueAnalysis/grid/VenueAnalysisSankey';

interface OrderLiquidityVenueSankeyProps {
    data: VenueAnalysisData;
    selection?: VenueAnalysisSelection;
    width: number;
}

export function OrderLiquidityVenueSankey({
    data,
    selection,
    width: containerWidth,
}: OrderLiquidityVenueSankeyProps) {
    if (!isVenueSelected(selection)) {
        return <></>;
    }

    const getData = (width: number) =>
        getVenueToLiquiditySankeyData(width, data, selection);

    return (
        <div className="OrderLiquidityVenueSankey">
            <VenueAnalysisSankey
                width={containerWidth}
                height={50}
                getData={getData}
            />
        </div>
    );
}
